export default {
    picture_url: 'http://localhost:3011/api/v1/witapp/picture',
};
